import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
} from '@react-pdf/renderer';

// Estilos para el PDF
const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: 'Helvetica',
  },
  header: {
    backgroundColor: '#000000',
    color: '#ffffff',
    padding: 12,
    textAlign: 'center',
    marginBottom: 15,
  },
  headerText: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  placaContainer: {
    textAlign: 'center',
    borderBottom: '2px solid #000000',
    paddingBottom: 15,
    marginBottom: 15,
  },
  placa: {
    fontSize: 48,
    fontWeight: 'bold',
    letterSpacing: 4,
  },
  infoGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    marginBottom: 15,
  },
  infoBox: {
    width: '48%',
    border: '2px solid #000000',
    padding: 10,
    marginBottom: 8,
    marginRight: '2%',
  },
  infoLabel: {
    fontSize: 8,
    color: '#666666',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    marginBottom: 4,
  },
  infoValue: {
    fontSize: 24,
    fontWeight: 'bold',
  },
  infoValueSmall: {
    fontSize: 18,
    fontWeight: 'bold',
  },
  guiasBox: {
    border: '2px solid #000000',
    padding: 10,
    marginBottom: 15,
  },
  guiaText: {
    fontSize: 10,
    fontFamily: 'Courier',
    marginBottom: 2,
  },
  alertsContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    gap: 10,
    marginBottom: 15,
  },
  alertDG: {
    backgroundColor: '#FFC107',
    border: '2px solid #000000',
    padding: 10,
    textAlign: 'center',
    minWidth: 100,
  },
  alertOversize: {
    backgroundColor: '#FF9800',
    border: '2px solid #000000',
    padding: 10,
    textAlign: 'center',
    minWidth: 100,
  },
  alertTitle: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  alertSubtitle: {
    fontSize: 8,
    fontWeight: 'bold',
  },
  notasBox: {
    border: '2px solid #000000',
    padding: 10,
    backgroundColor: '#f0f0f0',
    marginBottom: 15,
  },
  footer: {
    borderTop: '2px solid #000000',
    paddingTop: 10,
    flexDirection: 'row',
    justifyContent: 'space-between',
  },
  footerText: {
    fontSize: 9,
    color: '#666666',
  },
  barcodeContainer: {
    borderTop: '4px solid #000000',
    padding: 12,
    textAlign: 'center',
    backgroundColor: '#f5f5f5',
    marginTop: 15,
  },
  barcodeText: {
    fontSize: 14,
    fontFamily: 'Courier',
    letterSpacing: 2,
  },
});

const PalletLabelPDF = ({ pallet, vuelo }) => {
  const hasDG = pallet?.dg;
  const hasOversize = pallet?.xl && pallet?.xl !== 'N/A';

  return (
    <Document>
      <Page size={[288, 432]} style={styles.page}> {/* 4x6 inches */}
        {/* Header */}
        <View style={styles.header}>
          <Text style={styles.headerText}>VUELO: {vuelo?.awb}</Text>
        </View>

        {/* Placa */}
        <View style={styles.placaContainer}>
          <Text style={styles.placa}>{pallet?.placa}</Text>
        </View>

        {/* Info Grid */}
        <View style={styles.infoGrid}>
          <View style={styles.infoBox}>
            <Text style={styles.infoLabel}>Destino</Text>
            <Text style={styles.infoValue}>{vuelo?.Destino}</Text>
          </View>
          <View style={styles.infoBox}>
            <Text style={styles.infoLabel}>Peso Total</Text>
            <Text style={styles.infoValue}>{pallet?.pesoTotalP} KG</Text>
          </View>
          <View style={styles.infoBox}>
            <Text style={styles.infoLabel}>Posición</Text>
            <Text style={styles.infoValueSmall}>{pallet?.tipoPos}</Text>
          </View>
          <View style={styles.infoBox}>
            <Text style={styles.infoLabel}>Total Piezas</Text>
            <Text style={styles.infoValueSmall}>{pallet?.total_piezas} PCS</Text>
          </View>
        </View>

        {/* Guías */}
        <View style={styles.guiasBox}>
          <Text style={styles.infoLabel}>Guías</Text>
          {pallet?.guias?.map((guia, idx) => (
            <Text key={idx} style={styles.guiaText}>{guia}</Text>
          ))}
        </View>

        {/* Alerts */}
        {(hasDG || hasOversize) && (
          <View style={styles.alertsContainer}>
            {hasDG && (
              <View style={styles.alertDG}>
                <Text style={styles.alertTitle}>DG</Text>
                <Text style={styles.alertSubtitle}>DANGEROUS GOODS</Text>
              </View>
            )}
            {hasOversize && (
              <View style={styles.alertOversize}>
                <Text style={styles.alertTitle}>{pallet?.xl}</Text>
                <Text style={styles.alertSubtitle}>OVERSIZE</Text>
              </View>
            )}
          </View>
        )}

        {/* Notas */}
        {pallet?.notas2 && (
          <View style={styles.notasBox}>
            <Text style={styles.infoLabel}>Notas</Text>
            <Text style={{ fontSize: 10 }}>{pallet?.notas2}</Text>
          </View>
        )}

        {/* Footer */}
        <View style={styles.footer}>
          <Text style={styles.footerText}>
            Fecha: {vuelo?.fecha ? new Date(vuelo.fecha).toLocaleDateString() : '-'}
          </Text>
          <Text style={styles.footerText}>
            Equipo: {vuelo?.equipo_nombre}
          </Text>
        </View>

        {/* Barcode */}
        <View style={styles.barcodeContainer}>
          <Text style={styles.barcodeText}>
            ||| {pallet?.placa} - {vuelo?.awb} |||
          </Text>
        </View>
      </Page>
    </Document>
  );
};

export default PalletLabelPDF;

